import { ReportsBreakdown } from "../../components/ReportsBreakdown";

export const View = (props) => {
  return (
    <>
      <ReportsBreakdown
        queryStringTabs={props.queryStringTabs}
        title="Balance"
        subtitle="Balance summary"
        summary="Shows starting and ending balance in your SwitchApp account. Starting balance is the sum of your available balance and pending balance. Changes to your balance come from activity (payments, refunds, transfers, etc.) and from payouts to your bank (aggregated here and broken out in detail in the reports below)."
        detail1="Starting balance —Jul 1, 2022 13:00pm"
        detail2="Net balance change from activity"
        detail3="Ending balance —Aug 1, 2022 18:00pm"
        detail1num="₦350000"
        detail2num="₦450000"
        detail3num="₦650000"
        subtitle2="Ending balance —Aug 1, 2022 18:00pm"
        subtitle2num="₦3000000"
        subtitle3="Balance change from activity"
        subtitle3summary="Detailed breakdown of the balance change from activity line from the above summary report includes changes to your stripe balance from activity payments, refunds, transfers, etc, excluding payouts as well as itemized downloads."
        row1a="Changes"
        row1b="Counts"
        row1c="300"
        row2b="Gross amount"
        row2c="₦700000"
        row3a="Refunds"
        row3b="Counts"
        row3d="₦400000"
        row3c="10"
        row4b="Gross amount"
        row4c="₦400000"
        row5b="Gross amount"
        row5c="₦400000"
        subtitle4="Payouts"
        subtitle4summary="Detailed breakdown of the total payouts line from the above Balances Summaey report includes changes to your SwitchApp balance, from payouts to your bank, as well as itemized downloads"
        balanceactivity="Balance change from activity"
        activitynum="310"
        activityamount="₦1450000"
        row6a="Payouts"
        row6b="Counts"
        row6c="300"
        row7a="Gross amount"
        row7b="₦40000"
        downloadbutton=""
      />
    </>
  );
};
